import React from "react";
import { useState } from "react";
import BoxModal from "./BoxesModal";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { useEffect } from "react";
import { MoneyMask } from "@/app/core/util/helpers/MoneyHelper";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import OnDataChange from "@/app/core/util/helpers/HandleChange";

export default function BoxItem({ data, report, delivery, presentation, removeBox, hideContent, duplicate, isNational, reportBox }) {
    const [open, setOpen] = useState(true);
    const date = new Date;
    const [showModal, setShowModal] = useState(false);
    const [edit, setEdit] = useState(false);
    const [items, setItems] = useState([]);
    const [selected, setSelected] = useState({});
    const [infos, setInfos] = useState({});

    useEffect(() => {

        if (infos.items && infos.items.length > 0) {
            setItems(infos.items)
        }
        setInfos(data);
    }, [hideContent, delivery, data])

    useEffect(() => {
        processBoxPrice()
    }, [items])

    function toggleCard() {
        setOpen(!open);
    }

    function addItem(item) {
        let base = [...items, { ...item, box_id: infos.id, id: items.length + 1 }];
        setItems(base);
        setShowModal(true);
        report(base)
    }

    function duplicateItem(item) {
        setItems([...items, { ...item, id: items.length + 1 }]);
    }

    function handleChange(evt, type) {
        setInfos(OnDataChange(infos, evt, type))
    }

    function removeItem(index) {
        if (window.confirm(Translate(Message.DeleteConfirm))) {

            let old = [];
            for (let s in items) {
                if (s != index) {
                    old.push(items[s])
                }
            }
            setItems(old);
            report(old)
        }
    }

    function editItem(item) {
        setSelected(item)
        setShowModal(true);
    }

    function update(item) {
        let oldItens = items;
        oldItens[item.id - 1] = item;

        setItems(oldItens);
        report(oldItens)
    }

    function processBoxPrice() {
        if (items.length > 0) {
            let total = 0;//items.reduce(function (acc, val) { return acc + (val.unit_value * val.quantity); }, 0);

            let weight = 0;//items.reduce(function (acc, val) { return acc + (val.quantity * val.weight); }, 0);

            for (let s in items) {
                const item = items[s];
                total += item.unitValue * item.quantity;
                weight += item.weight * item.quantity;
            }

            let newBox = data;
            newBox.price = total;
            newBox.weight = weight;
            if (reportBox != undefined) {
                reportBox(newBox);
            }
        }
    }

    function handleSave() {
        if (edit == true) {
            setEdit(false);
            if (reportBox != undefined) {
                reportBox(infos);
            }
        } else {
            setEdit(true);
        }
    }

    return (
        <a className={"block block-rounded block-link-shadow block-bordered border-info border-3x"} href="javascript:void(0)">
            <div className="block-header">
                <div className="block-title inline-block">
                    {edit == true ?
                        <span>
                            Nome da caixa:
                            <input className="form-control" type="text" name="name" value={infos.name} onChange={evt => handleChange(evt)} />
                        </span>
                        :
                        <span><img src="assets/media/box.png" height={40} /> -
                            {infos && infos.name}
                        </span>
                    }
                </div>
                <div className="block-tools">
                    {((hideContent && hideContent.object != "not_doc") || presentation == true || (delivery && delivery.origin && delivery.origin.country_code == "BR" && delivery.destination.country_code == "BR")) ? "" :
                        <span className="btn btn-sm btn-square btn-outline-dark" onClick={() => setShowModal(true)}>
                            <i className="si si-plus mr-2" />{Translate(Message.Content)}
                        </span>
                    }
                    {(presentation == true) ? "" :
                        <span className="btn btn-sm btn-square btn-outline-dark" onClick={() => handleSave()}>
                            {edit == true ?
                                <span>
                                    <i className="si si-check mr-2" />{Translate(Message.Save)}
                                </span>
                                :
                                <span>
                                    <i className="far fa-edit mr-2" />{Translate(Message.Edit)}
                                </span>
                            }
                        </span>
                    }
                    {items && items.length > 0 ?
                        <button
                            className="btn btn-sm btn-square btn-outline-dark js-click-ripple-enabled"
                            onClick={() => toggleCard()}>
                            <i className={`si si-arrow-${open === true ? "up" : "down"}`}></i>
                        </button>
                        : ""}
                    {presentation != true ?
                        <button
                            className="btn btn-sm btn-square btn-outline-info js-click-ripple-enabled"
                            onClick={() => duplicate()}>
                            <i className={`far fa-copy mr-2`}></i> {Translate(Message.Duplicate)}
                        </button>
                        : ""}
                    {presentation != true ?
                        <button
                            className="btn btn-sm btn-square btn-outline-dark js-click-ripple-enabled"
                            onClick={() => removeBox()}>
                            <i className={`si si-close text-danger`}></i> {Translate(Message.Delete)}
                        </button>
                        : ""}
                </div>
            </div>
            {/* <table className="table text-center">
                <tbody>
                    <tr className="row">
                        <td className="col-md-2">{Translate(Message.Height)}: {infos && infos.height}cm</td>
                        <td className="col-md-2">{Translate(Message.Width)}: {infos && infos.width}cm</td>
                        <td className="col-md-2">{Translate(Message.Depth)}: {infos && infos.depth}cm</td>
                        <td className="col-md-2">{Translate(Message.Weigth)}: {infos && infos.weight}Kg</td>
                        <td className="col-md-2">{Translate(Message.Value)}: R${infos && MoneyMask(infos.price,2)}</td>
                    </tr>
                </tbody>
            </table> */}
            <div className="row ml-1 mr-1">
                <div className="col-md-6 col-sm-6 text-sm">{Translate(Message.Depth)}:
                    {edit == true ?
                        <input className="form-control" type="number" name="depth" value={infos.depth} onChange={evt => handleChange(evt, FieldTypeObj.Decimal)} />
                        :
                        <span>
                            {infos && infos.depth}cm
                        </span>
                    }

                    <br />

                    {Translate(Message.Height)}:
                    {edit == true ?
                        <input className="form-control" type="number" name="height" value={infos.height} onChange={evt => handleChange(evt, FieldTypeObj.Decimal)} />
                        :
                        <span>
                            {infos && infos.height}cm
                        </span>
                    }
                </div>
                <div className="col-md-6 col-sm-6 text-sm">
                    {/* {infos && infos.width}cm */}
                    {Translate(Message.Width)}:
                    {edit == true ?
                        <input className="form-control" type="number" name="width" value={infos.width} onChange={evt => handleChange(evt, FieldTypeObj.Decimal)} />
                        :
                        <span>
                            {infos && infos.width}cm
                        </span>
                    }
                    <br />
                    {Translate(Message.Weigth)}:
                    {edit == true ?
                        <input className="form-control" type="number" name="weight" value={infos.weight} onChange={evt => handleChange(evt, FieldTypeObj.Decimal)} />
                        :
                        <span>
                            {infos && infos.weight}Kg
                        </span>
                    }
                </div>
                <div className="col-md-6 col-sm-6 text-sm">

                    {Translate(Message.Value)}:
                    {edit == true ?
                        <input className="form-control" type="number" name="price" value={infos.price} onChange={evt => handleChange(evt, FieldTypeObj.Decimal)} />
                        :
                        <span>
                            R${infos && MoneyMask(infos.price, 2)}
                        </span>
                    }
                </div>
            </div>
            {open == true ?
                <div className="block-content">
                    {items.map((item, index) => (
                        <div className="block block-rounded block-link-shadow block-bordered border-success">
                            <div className="block-header">
                                <div className="block-title">
                                    {item.quantity} - {item.name}
                                </div>
                                {presentation != true ?
                                    <div className="block-tools">
                                        <button className="btn btn-dual" onClick={() => editItem(item)}>
                                            <i className="far fa-edit mr-1" />
                                            {Translate(Message.Edit)}
                                        </button>
                                        <button className="btn btn-dual" onClick={() => duplicateItem(item)}>
                                            <i className="far fa-copy mr-1" />
                                            {Translate(Message.Duplicate)}
                                        </button>
                                        <button className="btn btn-dual" onClick={() => removeItem(index)}>
                                            <i className="si si-close mr-1" />
                                            {Translate(Message.Delete)}
                                        </button>
                                    </div>
                                    : ""}

                            </div>
                        </div>
                    ))}
                </div>
                : ""}
            <BoxModal
                show={showModal}
                isNational={isNational}
                selected={selected}
                onHide={() => setShowModal(false)}
                register={item => addItem(item) | setShowModal(false) | setSelected({})}
                update={(item) => update(item) | setShowModal(false) | setSelected({})}
            />
        </a>
    )
}